import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { FormControl } from '@angular/forms';

import { OrganizationQuery } from '@shared/store/organization/organization.query';
import { PeriodType } from '@shared/utils/utils';

import { BudgetCompareMenuPeriodComponent } from './components/budget-compare-menu-period/budget-compare-menu-period.component';
import { BudgetCompareMenuSnapshotComponent } from './components/budget-compare-menu-snapshot/budget-compare-menu-snapshot.component';
import { BudgetCompareMenuVendorComponent } from './components/budget-compare-menu-vendor/budget-compare-menu-vendor.component';
import {
  BudgetCompareMenuFlatten$,
  BudgetCompareMenuPeriodFormControl,
  BudgetCompareMenuPeriodList,
  BudgetCompareMenuSnapshotChangeFn,
  BudgetCompareMenuSnapshotDisabled,
  BudgetCompareMenuSnapshotFormControl,
  BudgetCompareMenuSnapshotList,
  BudgetCompareMenuSnapshotLoading,
  BudgetCompareMenuSnapshotRefreshFn,
  BudgetCompareMenuSnapshotShowDelete,
  BudgetCompareMenuSnapshotShowEdit,
  BudgetCompareMenuSnapshotValue,
  BudgetCompareMenuVendorChangeFn,
  BudgetCompareMenuVendorFormControl,
  BudgetCompareMenuVendorLoading,
  defaultPeriodList,
  defaultSnapshotChangeFn,
  defaultSnapshotRefreshFn,
  defaultVendorChangeFn,
} from './models/budget-compare-menu.models';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    BudgetCompareMenuVendorComponent,
    BudgetCompareMenuSnapshotComponent,
    BudgetCompareMenuPeriodComponent,
  ],
  selector: 'aux-budget-compare-menu',
  templateUrl: './budget-compare-menu.component.html',
})
export class BudgetCompareMenuComponent {
  private organizationQuery = inject(OrganizationQuery);

  @Input() periodFormControl: BudgetCompareMenuPeriodFormControl;
  @Input() periodList: BudgetCompareMenuPeriodList;
  @Input() snapshotChangeFn: BudgetCompareMenuSnapshotChangeFn;
  @Input() snapshotDisabled: BudgetCompareMenuSnapshotDisabled;
  @Input() snapshotFormControl: BudgetCompareMenuSnapshotFormControl;
  @Input() snapshotList: BudgetCompareMenuSnapshotList;
  @Input() snapshotLoading: BudgetCompareMenuSnapshotLoading;
  @Input() snapshotRefreshFn: BudgetCompareMenuSnapshotRefreshFn;
  @Input() snapshotShowDelete: BudgetCompareMenuSnapshotShowDelete;
  @Input() snapshotShowEdit: BudgetCompareMenuSnapshotShowEdit;
  @Input() snapshotValue: BudgetCompareMenuSnapshotValue;
  @Input() vendorChangeFn: BudgetCompareMenuVendorChangeFn;
  @Input() vendorFormControl: BudgetCompareMenuVendorFormControl;
  @Input() vendorList: BudgetCompareMenuFlatten$<typeof this.organizationQuery.allVendors$>;
  @Input() vendorLoading: BudgetCompareMenuVendorLoading;

  constructor() {
    this.vendorFormControl = new FormControl('', {
      nonNullable: true,
    });
    this.vendorList = [];
    this.vendorLoading = false;
    this.vendorChangeFn = defaultVendorChangeFn;

    this.snapshotFormControl = new FormControl('', {
      nonNullable: true,
    });
    this.snapshotList = [];
    this.snapshotValue = '';
    this.snapshotDisabled = false;
    this.snapshotShowEdit = true;
    this.snapshotShowDelete = true;
    this.snapshotLoading = false;
    this.snapshotChangeFn = defaultSnapshotChangeFn;
    this.snapshotRefreshFn = defaultSnapshotRefreshFn;

    this.periodFormControl = new FormControl<string>(PeriodType.PERIOD_MONTH, {
      nonNullable: true,
    });
    this.periodList = defaultPeriodList;
  }
}
